import { useState } from 'react'
import { Plus, FileText } from 'lucide-react'
import { ConciergeChat } from '@/features/concierge/components/ConciergeChat'
import { ConciergeSessionsPicker } from '@/features/concierge/components/ConciergeSessionsPicker'
import { PennReviewModal } from '@/features/concierge/components/PennReviewModal'
import '@/features/concierge/components/concierge.css'
import { useConciergeStore } from '@/stores/useConciergeStore'

/**
 * The FULL Concierge experience composed for an embedded rail: session picker +
 * new-conversation + Penn Review, on top of <ConciergeChat/> (which itself
 * carries the mode banner + streaming). Wrapped in `concierge-root` so the
 * dark token theme + chat styles apply. Mirrors what ConciergePage assembles,
 * minus the standalone full-page chrome.
 */
export function ConciergeRail() {
  const newSession = useConciergeStore((s) => s.newSession)
  const enterMode = useConciergeStore((s) => s.enterMode)
  const [pennOpen, setPennOpen] = useState(false)

  return (
    <div className="concierge-root flex h-full min-h-0 flex-col bg-background text-foreground">
      <div className="flex h-11 shrink-0 items-center gap-1.5 border-b border-border px-3">
        <span className="text-xs font-medium text-muted-foreground">Concierge</span>
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" title="live" />
        <div className="ml-auto flex items-center gap-1">
          <button
            onClick={() => newSession()}
            title="New conversation"
            className="rounded p-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
          >
            <Plus size={15} strokeWidth={1.75} />
          </button>
          <button
            onClick={() => setPennOpen(true)}
            title="Penn Review"
            className="flex items-center gap-1 rounded border border-border px-2 py-1 text-[11px] text-muted-foreground transition-colors hover:text-foreground"
          >
            <FileText size={12} strokeWidth={1.75} />
            penn
          </button>
          <ConciergeSessionsPicker />
        </div>
      </div>

      <div className="min-h-0 flex-1">
        <ConciergeChat />
      </div>

      <PennReviewModal
        open={pennOpen}
        onClose={() => setPennOpen(false)}
        onSubmit={(p) => {
          enterMode('penn_review', {
            dateFrom: p.dateFrom,
            dateTo: p.dateTo,
            contextNote: p.contextNote,
            writeToVault: p.writeToVault,
            displayTitle: `${p.dateFrom} → ${p.dateTo}`,
          })
          setPennOpen(false)
        }}
      />
    </div>
  )
}
